export const USER_FACTOR_TYPE = {
  SMS: "SMS",
  EMAIL: "EMAIL",
  TOTP: "TOTP"
};
